// extracted by mini-css-extract-plugin
export default {"sticky-container":"sticky-footer__sticky-container___1Ajig","container":"sticky-footer__container___DvOaZ"};